<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card">
        <Toolbar class="p-mb-4 p-p-2">
          <template #start>
            <div style="font-size: 1.4em; color: inherit" class="p-p-2">{{ $t('Suspicious Activity') }}</div>
          </template>
          <template #end>
            <SearchInput :disabled="dataTableIsLoading" @change-processed-search-value="changeProcessedSearchValue" v-model="searchData" @show-spinner="isLoading = true"/>
          </template>
        </Toolbar>

        <!--  Desktop DataTable -->
        <Spinner v-if="isLoading"/>
<!--        <DesktopDataTable v-else-if="!isLoading && !$store.state.tabletLayout"-->
        <DesktopDataTable v-else
                          :dataTableIsLoading="dataTableIsLoading"
                          :showHeader="false"
                          :itemsArrayIsEmpty="itemsArrayIsEmpty"
                          :sort="sort"
                          :showButtons="!!actionButtonsCount"
                          :showSearchInput="false"
                          :actionButtonsCount="actionButtonsCount"
                          @sort-items="sortItems"
                          :headers="[
                              {name: 'created_at', title: $t('Created'), sortable: true},
                              {name: 'screenshot_attempt_count', title: 'Screenshot Attempt Count', sortable: false},
                              {name: 'devtools_opened', title: 'Devtools Opened', sortable: false},
                              {name: 'user', title: $t('User'), sortable: false},
                              {name: 'tenant', title: $t('Tenant'), sortable: false},
                              {name: 'suspicious_context', title: 'Context UI', sortable: false},
                          ]">
          <template v-slot:body>
            <tr v-for="(item, index) of items"
                :key="item.id ?? index"
                :class="{'updated-item': isItemUpdated(item.id)}">
              <td>
                {{ formatDate(item.created_at, true) }}
              </td>

              <td>
                {{ item.screenshot_attempt_count || 0 }}
              </td>

              <td>
<!--                <i class="pi pi-check warning-color" style="font-size: 1.3rem" v-if="item.devtools_opened && +item.devtools_opened"/>-->
                <i class="ti-alert warning-color medium-bold-text" style="font-size: 1.3rem" v-if="item.devtools_opened && +item.devtools_opened"/>
<!--                <i class="pi pi-times green-color" v-else/>-->
                <i class="ti-minus" v-else/>
              </td>
              <td>
                <span v-if="item.user">{{ item.user.first_name ?? '' }} {{ item.user.last_name ?? '' }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.tenant_name">{{ item.tenant_name }}</span>
                <i v-else class="ti-minus"/>
              </td>

<!--              <td>-->
<!--                <span v-if="item.suspicious_context">{{ item.suspicious_context }}</span>-->
<!--                <i v-else class="ti-minus"/>-->
<!--              </td>-->

              <td class="context-ui-cell">
                <div v-if="getSuspiciousContextRows(item.suspicious_context).length"
                     class="context-ui-list">
                  <div v-for="(row, index) in getVisibleSuspiciousContextRows(item)"
                       :key="index"
                       class="context-ui-row">
                    <span class="context-ui-badge"
                          :class="`context-ui-badge--${row.type}`">
                      {{ getSuspiciousEventTitle(row.type) }}
                    </span>

                    <span class="context-ui-count">×{{ row.count }}</span>
                    <span class="context-ui-route"
                         :title="row.route_path">
                      {{ getSuspiciousRouteLabel(row) }}
                    </span>
                  </div>

                  <button v-if="getHiddenSuspiciousContextRowsCount(item) > 0"
                          type="button"
                          class="context-ui-more"
                          @click.stop="showAllSuspiciousContextRows(item.id)">
                    +{{ getHiddenSuspiciousContextRowsCount(item) }} more
                  </button>
                </div>

                <i v-else class="ti-minus"/>
              </td>

            </tr>
          </template>
        </DesktopDataTable>

        <OwnPaginator v-show="!itemsArrayIsEmpty"
                      :rows="pagination.perPage"
                      :currentPage="pagination.currentPage - 1"
                      :totalPages="pagination.pageCount"
                      :totalRecords="pagination.totalCount"
                      :rowsPerPageOptions="[5,10,25,50,100,200]"
                      :pageLinkSize="11"/>

        <TotalRecordsData :pagination="pagination" :itemsArrayIsEmpty="itemsArrayIsEmpty"/>
			</div>
		</div>
	</div>
</template>

<script>
import httpClient from '@/services/http.services'
import formatMixins from "@/mixins/formatMixins";
import datatableMixins from "@/mixins/datatableMixins";
import settings from "@/settings";
import showErrorsMixins from "@/mixins/showErrorsMixins";

export default {
  mixins: [ formatMixins, datatableMixins, showErrorsMixins ],
	data() {
		return {
      expandedSuspiciousContextRows: {},
      fieldsExpand: 'user,tenant_name',
      apiLink: 'trial-security',
      routePath: '/suspicious-activity',
      searchData: '',
      sort: {
        column: 'created_at',
        direction: '-',
      },
		}
	},
  mounted() {
    this.scrollToTop()
    if (settings.autoLogoutTimeout && this.$store.state.logoutTimestampIsOverdue) return false
    this.checkRouteQuery()
    this.getPageData()
	},
  methods: {
    getPageData() {
      this.getItems()
    },
    async getItems() {
      // if (!this.$store.getters.isUserReady) return
      if (!this.userCanGetData || this.fetchInFlight) return
      this.$store.commit('SET_FETCH_IN_FLIGHT', true)
      this.dataTableIsLoading = true
      const ctrl = this.setController?.('tenantSuspiciousActivity')
      try {
        const { status, data, headers } = await httpClient({
          url: this.apiLink,
          params: {
            // type: this.selectedTypeId,
            page: this.pagination.currentPage,
            'per-page': this.pagination.perPage,
            sort: this.sort.direction + this.sort.column,
            search: this.processedSearchValue ?? null,
            expand: this.fieldsExpand,
          },
          signal: ctrl?.signal
        })
        if (status === 200 && data && Array.isArray(data)) {
          const hasPaginationHeaders = !!headers['x-pagination-total-count']
          if (hasPaginationHeaders) {
            this.pagination.totalCount = +headers['x-pagination-total-count']
            this.pagination.pageCount  = +headers['x-pagination-page-count']
          } else {
            this.pagination.totalCount = data.length
            this.pagination.pageCount  = 1
          }

          this.items = data

          if (!data.length) {
            this.pagination.pageCount = 1
            this.pagination.currentPage = 1
          }
        } else {
          this.showUnknownError()
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.$store.commit('SET_FETCH_IN_FLIGHT', false)
        this.dataTableIsLoading = false
        this.isLoading = false
        if (this._abortors?.tenantSuspiciousActivity === ctrl) {
          this._abortors.tenantSuspiciousActivity = null
        }
      }
    },
    parseSuspiciousContext(value) {
      if (!value) return null

      if (typeof value === 'object') {
        return value
      }

      try {
        return JSON.parse(value)
      } catch (e) {
        return null
      }
    },

    getSuspiciousContextRows(value) {
      const context = this.parseSuspiciousContext(value)

      if (!context || typeof context !== 'object') {
        return []
      }

      const rows = {}

      const types = [
        'screenshot_attempt',
        'devtools_opened',
      ]

      types.forEach((type) => {
        if (!Array.isArray(context[type])) return

        context[type].forEach((item) => {
          const routePath = item.route_path || 'unknown'
          const routeName = item.route_name || null
          const key = `${type}:${routePath}:${routeName || ''}`

          if (!rows[key]) {
            rows[key] = {
              type,
              route_name: routeName,
              route_path: routePath,
              count: 0,
              first_at: item.first_at || null,
              last_at: item.last_at || item.first_at || null,
            }
          }

          rows[key].count += Number(item.count || 1)

          if (item.first_at && (!rows[key].first_at || item.first_at < rows[key].first_at)) {
            rows[key].first_at = item.first_at
          }

          if (item.last_at && (!rows[key].last_at || item.last_at > rows[key].last_at)) {
            rows[key].last_at = item.last_at
          }
        })
      })

      return Object.values(rows).sort((a, b) => {
        return Number(b.last_at || 0) - Number(a.last_at || 0)
      })
    },

    getSuspiciousEventTitle(type) {
      return {
        screenshot_attempt: 'Screenshot',
        devtools_opened: 'DevTools',
      }[type] || type
    },
    // getSuspiciousEventShortTitle(type) {
    //   return {
    //     screenshot_attempt: 'Scr',
    //     devtools_opened: 'Dev',
    //   }[type] || type
    // },
    getSuspiciousRouteLabel(row) {
      return row.route_name || row.route_path || '-'
    },

    getVisibleSuspiciousContextRows(item) {
      const rows = this.getSuspiciousContextRows(item.suspicious_context)

      if (this.expandedSuspiciousContextRows[item.id]) {
        return rows
      }

      return rows.slice(0, 5)
    },

    getHiddenSuspiciousContextRowsCount(item) {
      const rows = this.getSuspiciousContextRows(item.suspicious_context)

      if (this.expandedSuspiciousContextRows[item.id]) {
        return 0
      }

      return Math.max(rows.length - 5, 0)
    },

    showAllSuspiciousContextRows(itemId) {
      this.expandedSuspiciousContextRows = {
        ...this.expandedSuspiciousContextRows,
        [itemId]: true,
      }
    },
	},
  computed: {
    actionButtonsCount() {
      return 0
    },
  }
}
</script>
<style scoped lang="scss">
.context-ui-cell {
  width: 320px;
  min-width: 260px;
  max-width: 320px;
  overflow: hidden;
}

.context-ui-list {
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
}

.context-ui-row {
  display: grid;
  grid-template-columns: 74px 28px minmax(0, 1fr);
  align-items: center;
  column-gap: 6px;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  min-height: 22px;
  overflow: hidden;
  font-size: 12px;
  line-height: 1.2;
}

.context-ui-badge {
  display: inline-flex;
  justify-content: center;
  max-width: 74px;
  padding: 2px 5px;
  border-radius: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11px;
  font-weight: 500;
}

.context-ui-count {
  min-width: 0;
  overflow: hidden;
  font-weight: 500;
  font-size: 11px;
  white-space: nowrap;
}

.context-ui-route {
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  //font-weight: 500;
}

.context-ui-badge--screenshot_attempt {
  background: #fff7ed;
  color: #c2410c;
}

.context-ui-badge--devtools_opened {
  background: #fef2f2;
  color: #b91c1c;
}

.context-ui-count {
  font-weight: 500;
  font-size: 11px;
  white-space: nowrap;
}

.context-ui-more {
  display: inline-flex;
  align-self: flex-start;
  padding: 0;
  border: 0;
  background: transparent;
  color: #0288D1;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
}
</style>